export const LOGIN = "/";

export const NEW_PASSWORD = "/new-password/:token";

export const APP = "/app";

export const RESERVATIONS = "/app/reservations";
export const RESERVATIONS_HISTORY = "/app/reservations/history";
export const RESERVATION_HISTORY_DETAILS = "/app/reservations/history/details";

export const ORDERS = "/app/orders";
export const ORDERS_PAST = "/app/orders/past-orders";
export const ORDER_PRODUCTS = "/app/orders/order-products";
export const ORDER_SETTINGS = "/app/orders/order-settings";

export const CUSTOMERS = "/app/clients";
export const CUSTOMER_DETAILS = "/app/clients/details";

export const FEEDBACKS = "/app/feedbacks";
export const SURVEYS = "/app/surveys";
export const SURVEY_EDITOR = "/app/surveys/editor";
export const SURVEYS_SETTINGS = "/app/surveys/settings";

export const STRIPE_INTEGRATION_SETTINGS = "/app/integrations/stripe";
export const GOOGLE_INTEGRATION_SETTINGS = "/app/integrations/google";
export const RESTOMAX_INTEGRATION_SETTINGS = "/app/integrations/restomax";

export const MESSAGES = "/app/messages";

export const STATS = "/app/stats";
export const PAYMENTS = "/app/payments";

export const TABLES_SETTINGS = "/app/settings/tables";
export const TABLELINKS_SETTINGS = "/app/settings/tablelinks";
export const RESERVATIONS_SETTINGS = "/app/settings/reservations";
export const RESERVATIONS_PAGE_SETTINGS = "/app/settings/reservations-page";
export const SCHEDULE_SETTINGS = "/app/settings/schedule";
export const NOTIFICATIONS_SETTINGS = "/app/settings/notifications";
export const USERS_SETTINGS = "/app/settings/users";
export const ACCOUNT_SETTINGS = "/app/settings/account";
export const APP_SETTINGS = "/app/settings/application";
export const SUBSCRIPTION_SETTINGS = "/app/settings/subscription";
export const WALLET_SETTINGS = "/app/settings/subscription";

export const EMAIL = "/app/clients/email";

export const SHOP_MANAGEMENT = "/app/shopping";
export const SHOP_STATISTICS = "/app/shopping/statistics";
export const SHOP_CONFIGURATION = "/app/shopping/configuration";
export const SHOP_MONTHLY_INVOICES = "/app/shopping/invoices";
export const SHOP_SALES = "/app/shopping/sales";

export const SMS_HISTORY = "/app/sms/";

export const MESSAGING = "/app/messaging";

export const ANSWERING_MACHINE = "/app/answering-machine";
export const ANSWERING_MACHINE_SETTINGS = "/app/answering-machine/settings";


// WEBPACK FOOTER //
// ./src/routes.js